export default __webpack_public_path__ + "static/media/about-2.2b31ab53.png";